import { PortableText } from '@portabletext/react'
import classNames from 'classnames'
import { forwardRef, useContext } from 'react'
import { s_lesson } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { TEXT_SIZE, TextContext } from '../../../pages/[lang]/portal/materials/detail/[materialId]'
import EmptyPage from '../../common/EmptyPage'
import { ptComponents, updateMarksToBreak } from '../../sanity/util'

const MaterialPdfDocument = forwardRef((props: any, ref: any) => {
  const { insightData, materialData } = props
  const { textSize } = useContext(TextContext)
  const { t, isLocaleKO } = useTranslation()
  const questions = materialData?.course?.keyquestions

  // const PAGE_HEIGHT = 1045

  // const printElement = document.getElementById('printable')
  // if (printElement) {
  //   printElement.classList.add('temp-class-for-height')
  //   const height = printElement.clientHeight
  //   const numberOfPage = Math.ceil(height / PAGE_HEIGHT)
  //   const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT
  //   let requiredHeight = heightWithSingleHeader
  //   if (numberOfPage > 1) {
  //     const headerHeight = printElement.getElementsByTagName('thead')?.[0]?.clientHeight
  //     const footerHeight = printElement.getElementsByTagName('tfoot')?.[0]?.clientHeight
  //     requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight)
  //   }
  //   console.log('requiredHeight' + requiredHeight)
  //   printElement.style.height = `${requiredHeight}px`
  //   printElement.classList.remove('temp-class-for-height')
  // }
  // useEffect(() => {
  //   document.title = `[링글] ${materialData.course.id}_${materialData.course.title_en}`
  // }, [materialData.course.id, materialData.course.title_en])
  return (
    <>
      <table id="printable" className="printable" ref={ref}>
        <thead className="h-[50px]"></thead>
        <div className="section mb-[20px]">
          <div className="Hero4-32Bd mb-[20px]">{materialData?.course?.title_en}</div>
          {insightData?.paragraphList.map((item, i) => {
            const contentEn = updateMarksToBreak(item.paragraph_en.content)
            return (
              <div
                key={i}
                className={classNames(
                  textSize === TEXT_SIZE.SMALLER && 'Body2-14Md',
                  textSize === TEXT_SIZE.DEFAULT && 'Body1-16Md',
                  textSize === TEXT_SIZE.BIGGER && 'Title2-18Md',
                  'new-theme lists-class mb-[16px] flex flex-col break-keep'
                )}
              >
                <PortableText value={contentEn} components={ptComponents} />
              </div>
            )
          })}
        </div>
        <div className="section mb-[20px]">
          <div className="Hero4-32Bd mb-[20px]">{materialData?.course?.title_kr}</div>
          {insightData?.paragraphList.map((item, i) => {
            const contentKo = updateMarksToBreak(item.paragraph_ko.content)
            return (
              <div
                key={i}
                className={classNames(
                  textSize === TEXT_SIZE.SMALLER && 'Body2-14Md',
                  textSize === TEXT_SIZE.DEFAULT && 'Body1-16Md',
                  textSize === TEXT_SIZE.BIGGER && 'Title2-18Md',
                  'new-theme lists-class mb-[16px] flex flex-col break-keep'
                )}
              >
                <PortableText value={contentKo} components={ptComponents} />
              </div>
            )
          })}
        </div>
        <div>
          <div className="mb-[20px]">
            {materialData?.course?.article?.length > 0 && (
              <div className="mb-[20px]">
                <div className="Hero4-32Bd">Articles</div>
                {materialData?.course?.article?.map((item, i) => (
                  <a key={i} href={item.url} className="pb-[5px] font-bold text-blue-700 underline">
                    {item.title}
                  </a>
                ))}
              </div>
            )}
            {materialData?.course?.video?.length > 0 && (
              <div className="mb-[20px]">
                <div className="Hero4-32Bd">Videos</div>
                {materialData?.course?.video?.map((item, i) => {
                  return (
                    <a
                      key={i}
                      href={`https://www.youtube.com/watch?v=${item.code}`}
                      className="pb-[5px]  font-bold text-blue-700 underline"
                    >
                      {item.title}
                    </a>
                  )
                })}
              </div>
            )}
          </div>
          <div className="mb-[20px]">
            <div className="Hero4-32Bd mb-[20px] ">Discussion Questions</div>
            <div>
              <div>
                {questions?.map((item, i) => {
                  return (
                    <div key={item.id} className="mb-[10px] border-b">
                      <div className="mb-[20px] flex flex-row">
                        <div>
                          <div className="Caption-12Bd rounded-[4px] bg-purple-50 px-[6px] py-[2px] text-purple-500">
                            Q{i + 1}
                          </div>
                        </div>
                        <div className="row flex gap-[8px]">
                          <div className="px-[25px] leading-[22px]">{item.text}</div>
                          <div className="px-[25px] leading-[22px]">{item.text_ko}</div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          <div className="mb-[20px]">
            <div className="Hero4-32Bd mb-[20px]">Expressions</div>
            <div>
              <div>
                <>
                  {materialData.expressions?.length > 0 ? (
                    <>
                      {materialData.expressions.map((item, i) => {
                        return (
                          <div key={i} className={classNames({ 'border-b': item?.examples?.length > 0 }, 'mb-[25px]')}>
                            <div className="flex">
                              <div className="mb-[3px] mr-[10px] min-w-[120px] text-[20px] font-bold text-purple-500">
                                {item.expression}
                              </div>
                              <div>
                                {isLocaleKO && (
                                  <div className="text-h3 mb-[4px] text-[10px] font-medium">{item.meaning.ko}</div>
                                )}
                              </div>
                            </div>
                            <div className="mb-[10px] border-b pb-[5px]">{item.meaning.en}</div>
                            {item.tip && isLocaleKO && (
                              <div className="mb-[5px] border-b">
                                <div className="mb-[3px] font-medium">Ringle Tip</div>
                                <div className="mb-[5px]">{item.tip}</div>
                              </div>
                            )}
                            {item.examples && item.examples.length > 0 && (
                              <div>
                                <div>
                                  {item.examples.map((example, j) => (
                                    <div key={`example-${j}`}>
                                      <div className="mb-[3px] flex items-end text-[14px] font-bold">
                                        <div className="mr-[2px] ">{t(s_lesson.example)}</div>
                                        <div className="mr-[3px]">{j + 1}</div>
                                      </div>
                                      <div key={j} className="mb-[10px]">
                                        <p className="mb-2">{example.text}</p>
                                        {isLocaleKO && <p className="mb-0 text-[13px]">{example.meaning}</p>}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      })}
                    </>
                  ) : (
                    <div className="px-[16px]">
                      <EmptyPage title={t(s_lesson.does_not_provide_expressions)} />
                    </div>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
        <tfoot className="footer">
          본 교재는 당사 편집진이 제작하는 링글의 자산으로 저작권법에 의해 보호됩니다. 링글 플랫폼 외에서 자료를
          활용하시는 경우 당사와 사전 협의가 필요합니다.
        </tfoot>
      </table>
    </>
  )
})

MaterialPdfDocument.displayName = 'MaterialPdfDocument'
export default MaterialPdfDocument
